import {ActionList, ActionMenu, RelativeTime} from '@primer/react'
import {SinceSource} from '../../../routes/route-payload-types'
import {useEffectiveSelection} from '../data/use-effective-selection'

const sinceSourceDescriptionMap: Record<SinceSource, string> = {
  [SinceSource.Created]: 'Since this pull request was created',
  [SinceSource.LastReview]: 'Since your last review',
  [SinceSource.LastInteracted]: 'Since you last interacted',
  [SinceSource.ReadyForReview]: 'Since marked ready for review',
}

/** Selector dropdown for the Activity section — rendered in the CollapsiblePanel header */
export function ActivitySelector() {
  const {sinceSelectors, effectiveSelection, handleSelect} = useEffectiveSelection()
  if (!effectiveSelection || sinceSelectors.length === 0) return null

  return (
    <ActionMenu>
      <ActionMenu.Button size="small" variant="invisible">
        {sinceSourceDescriptionMap[effectiveSelection?.source ?? '']}
      </ActionMenu.Button>
      <ActionMenu.Overlay align="end">
        <ActionList selectionVariant="single">
          {sinceSelectors.map(selector => (
            <ActionList.Item
              key={selector.source}
              selected={selector.source === effectiveSelection?.source}
              onSelect={() => handleSelect(selector)}
            >
              {sinceSourceDescriptionMap[selector.source]}
              <ActionList.Description>
                <RelativeTime date={new Date(selector.timestamp)} />
              </ActionList.Description>
            </ActionList.Item>
          ))}
        </ActionList>
      </ActionMenu.Overlay>
    </ActionMenu>
  )
}
